exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.theme-test[data-v-a6e7845a] {\n  padding: 20px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  margin: 20px;\n}\n.theme-info ul[data-v-a6e7845a] {\n  list-style: none;\n  padding: 0;\n}\n.theme-info li[data-v-a6e7845a] {\n  margin: 5px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.preview-sidebar[data-v-a6e7845a],\n.preview-header[data-v-a6e7845a] {\n  padding: 15px;\n  margin: 10px 0;\n  border-radius: 5px;\n}\n.preview-button[data-v-a6e7845a] {\n  margin: 10px 0;\n}\n", ""]);

// exports
